// @ts-check

import React from 'react'
import ColButton from '../../../Elements/ColButton';
import OverWindow from '../../../Elements/OverWindow';
import FreelancerInvoiceService from '../../../Services/FreelancerInvoiceService';
import CaspianImage from '../../../Elements/CaspianImage';




class ViewInvoiceImageWindow extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
    }

    

    renderInfo()
    {
        return (
            <div className="">
                <div className="text-center">
                    <CaspianImage
                        src={()=>FreelancerInvoiceService.GetInvoiceImageFile(this.props.freelancerInvoiceId)} //it has to be a service promise
                        alt={"Invoice"}
                        style=	{{
                                    maxWidth: "100%",
                                }}
                        fileName={this.props.data.Filename}
                    />
                </div>
            </div>
        );
    }

    renderButtons()
    {
        return (
            <div className='buttonfooter' ><div className="container-fluid">
                <div className="row">
                    <ColButton
                        text="Close"
                        onClick={this.props.clickOnCancel}
                        spinning={this.state.saving}
                        disabled={this.state.saving}
                    />
                </div>
            </div></div>
        );
    }


    render()
    {
        return (
            <OverWindow
                clickOnCancel={() => this.props.clickOnCancel(false)}
                title="View Invoice Image"
                closeOnClickOutside={false}
                iconName="fa-solid fa-eye"
                verticalScroll={true}
            >
                <div className="m-2 p-2">
                    {this.renderInfo()}
                </div>
                {this.renderButtons()}
            </OverWindow>
        );

    }
}


export default ViewInvoiceImageWindow;
